import React, { useState, useContext } from "react"
import { TextInput } from "../Form/TextInput"
import { navigate } from "gatsby"
import {
  CustomForm,
  SubmitButton,
  BackToHome,
  Request,
  SuccessMessage,
  SubText,
} from "./style"
import gql from "graphql-tag"
import { ThemeContext } from "styled-components"

import { useMutation } from "@apollo/react-hooks"

const CREATE_CONTACT_ENQUIRY = gql`
  mutation CreateContactEnquiry(
    $name: String!
    $email: String!
    $phone: String!
    $message: String!
    $site: String!
  ) {
    createContactEnquiry(
      input: {
        clientMutationId: "CreateEnquiry"
        name: $name
        email: $email
        phone: $phone
        message: $message
        site: $site
      }
    ) {
      data
      success
    }
  }
`

const FormEg = () => {
  const [submitted, setSubmitted] = useState(false)
  const [createContactEnquiry] = useMutation(CREATE_CONTACT_ENQUIRY)

  const themeContext = useContext(ThemeContext)
  const currentSite = themeContext.site
  console.log('currentSite:', currentSite)

  const onSubmit = values => {
    setSubmitted(true)
    createContactEnquiry({
      variables: {
        email: values.email,
        phone: values.phone,
        name: values.name,
        message: values.message,
        site: currentSite,
      },
    })

    console.log(values)
  }
  return (
    <>
      {submitted && (
        <SubText submitted={submitted}>
          Thanks for your message! Someone from our team will be in touch as
          soon as possible.
        </SubText>
      )}
      <BackToHome
        submitted={submitted}
        label="Back to the homepage"
        onClick={() => {
          navigate("/")
        }}
      />
      <CustomForm submitted={submitted} noValidate onSubmit={onSubmit}>
        <TextInput
          name="name"
          error="Please enter a name "
          floatingLabel="Name"
        />

        <TextInput
          type="email"
          name="email"
          error="Please enter a valid email address"
          floatingLabel="Email"
        />

        <TextInput
          type="text"
          name="phone"
          error="Please enter a phone number"
          floatingLabel="Phone number"
        />
        <TextInput
          name="message"
          type="textarea"
          error="Please enter a message"
          floatingLabel="Message"
        />
        <SubmitButton submit label="Submit message" />
      </CustomForm>
    </>
  )
}

export default FormEg
